<app-tab>
  <dx-data-grid
    id="driversGridContainer"
    [dataSource]="ds"
    [libGridDefault]="{stateStorageKey: 'app-drivers-grid'}"
    [columnHidingEnabled]="false"
    (onEditingStart)="onEdit($event)"
    (onInitNewRow)="onCreate()"
    [libGridTitle]="{text: 'Opérateurs'}">

    <dxi-column
      caption="ID"
      dataField="id"
      sortOrder="desc"
      width="6%"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataType="number">
    </dxi-column>

    <dxi-column
      caption="Nom"
      dataField="name"
      dataType="string">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [min]="5" [max]="255"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Photo"
      dataField="photo"
      cssClass="photo-cell"
      [allowExporting]="false"
      [allowSorting]="false"
      [allowFiltering]="false"
      cellTemplate="photoTemplate"
      editCellTemplate="photoEditor"
      dataType="string">
      <div *dxTemplate="let cellInfo of 'photoEditor';">
        <lib-profile-photo-upload
          [value]="cellInfo.value"
          (valueChange)="cellInfo.setValue($event)"></lib-profile-photo-upload>
      </div>
    </dxi-column>

    <div *dxTemplate="let driverCell of 'photoTemplate'">
      <div class="photo" [style.backgroundImage]="'url(\'' + driverCell.data.photoUrl() + '\')'"></div>
    </div>

    <dxi-column
      caption="Téléphone"
      dataField="phone"
      dataType="string">
      <dxo-form-item
        [editorOptions]="{mask: '+212 0 00 00 00 00', maskRules: phonePattern, useMaskedValue:true}"></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="pattern" [pattern]="phonePattern"></dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [max]="45"></dxi-validation-rule>
    </dxi-column>


    <dxi-column
      caption="Cartes"
      cellTemplate="tagsCountTemplate"
      [allowEditing]="false"
      [visible]="canListTags"
      [formItem]="{visible: false}"
      dataField="tags_count">
    </dxi-column>


    <div *dxTemplate="let data of 'tagsCountTemplate'">
      <a href="#" (click)="showTags($event, data.data)" class="w-full flex items-center justify-end">
        <ic-icon [icon]="tagsIcon" width="18px" height="18px" [inline]="true"></ic-icon>
        <div class="px-1">({{data.value}})</div>
      </a>
    </div>

    <dxi-column
      caption="Domaine"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="domain_name">
    </dxi-column>

    <dxi-column
      caption="BU"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="business_unit_name">
    </dxi-column>

    <dxi-column
      caption="Date création"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="created_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Date modification"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="updated_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Domaine"
      dataField="domain_id"
      editCellTemplate="domainChooser"
      [visible]="false"
      [showInColumnChooser]="false">
      <div *dxTemplate="let cellInfo of 'domainChooser';">
        <app-user-domains-chooser (valueChange)="cellInfo.setValue($event)"
                                  [id]="cellInfo.value"></app-user-domains-chooser>
      </div>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxo-editing
      mode="popup"
      [allowDeleting]="canDelete"
      [allowAdding]="canAdd"
      [allowUpdating]="canEdit">

      <dxo-popup
        [title]="isNew ?  'Ajouter un opérateur' : current?.name"
        [showTitle]="true"
        width="40%" [height]="450"></dxo-popup>

      <dxo-form [colCount]="4">
        <dxi-item itemType="group">
          <dxi-item dataField="photo">
            <dxo-label [visible]="false"></dxo-label>
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colSpan]="3" [colCount]="1" caption="Données Personnelles">
          <dxi-item dataField="name"></dxi-item>
          <dxi-item dataField="phone"></dxi-item>
          <dxi-item dataField="domain_id"></dxi-item>
        </dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export [enabled]="true" fileName="liste-utilisateurs"
                [allowExportSelectedData]="true"></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-selection
      selectAllMode="page"
      mode="multiple"
    ></dxo-selection>

    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true">
    </dxo-pager>
    <dxo-filter-row
      [visible]="true"></dxo-filter-row>
    <dxo-search-panel
      [visible]="true"
      [width]="240"></dxo-search-panel>
    <dxo-header-filter
      [visible]="true"></dxo-header-filter>

  </dx-data-grid>
</app-tab>
<dx-popup
  width="70%"
  [showTitle]="true"
  [title]="'Cartes ' + taggable?.taggable_name"
  class="tags-viewer-popup"
  [(visible)]="tagsPopupVisible">
  <div *dxTemplate="let data of 'content'">
    <lib-tags-viewer [taggable]="taggable"></lib-tags-viewer>
  </div>
</dx-popup>
